var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-block"},[_c('img',{attrs:{"src":require("@/assets/images/empty.svg"),"alt":"empty"}})])
}]

export { render, staticRenderFns }